import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Search } from "lucide-react";
import { HardDeleteButton, RecordEditButton, DONOR_FIELDS } from "./SuperAdminTools";

export default function AdminDonors() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [denied, setDenied] = useState(false);
  const load = async () => { try { const r = await api.get("/admin/donors"); setItems(r.data); } catch (e) { if (e.response?.status === 403) setDenied(true); } };
  useEffect(() => { document.title = "Admin · Donors"; load(); }, []);


  const filtered = items.filter((b) => !q || (b.full_name + " " + b.serial + " " + b.email).toLowerCase().includes(q.toLowerCase()));
  const totals = items.reduce((acc, d) => { acc[d.currency] = (acc[d.currency] || 0) + d.amount; return acc; }, {});

  if (denied) return <div className="p-6 rounded-xl bg-[#f8f4e8] border border-[#d6aa43]/40 text-sm" data-testid="donors-denied">You do not have permission to view donor records. Ask the Super Admin for finance access.</div>;
  return (
    <div data-testid="admin-donors">
      <h1 className="font-serif text-3xl font-bold mb-2">Donor registry</h1>
      <div className="flex gap-3 flex-wrap mb-4">
        {Object.entries(totals).map(([cur, tot]) => (
          <div key={cur} className="bg-white border border-black/5 rounded-lg p-3 text-sm">
            <div className="text-xs text-[#0a0d12]/60">{cur} total</div>
            <div className="font-bold font-mono">{Number(tot).toLocaleString()}</div>
          </div>
        ))}
      </div>
      <div className="relative mb-4">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#0a0d12]/40" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" className="w-full pl-9 pr-3 py-2.5 border border-black/15 rounded-md text-sm" />
      </div>
      <div className="bg-white rounded-xl border border-black/5 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#f8f4e8] text-left">
            <tr>
              <th className="p-3">DON Serial</th><th className="p-3">Name</th><th className="p-3">Amount</th>
              <th className="p-3">Type</th><th className="p-3">Method</th><th className="p-3">Also BEN?</th><th className="p-3">Linked BEN</th><th className="p-3">Date</th><th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((d) => (
              <tr key={d.id} className="border-t border-black/5">
                <td className="p-3 font-mono text-xs">{d.serial}</td>
                <td className="p-3 font-semibold">{d.anonymous ? "Anonymous" : d.full_name}<div className="text-[10px] text-[#0a0d12]/50">{d.email}</div></td>
                <td className="p-3 font-bold">{d.currency} {Number(d.amount).toLocaleString()}</td>
                <td className="p-3 capitalize text-xs">{d.donation_type}</td>
                <td className="p-3 text-xs capitalize">{d.method}</td>
                <td className="p-3 text-xs">{d.also_register_beneficiary ? "Yes" : "No"}</td>
                <td className="p-3 font-mono text-[10px]">{d.linked_beneficiary_serial || "—"}</td>
                <td className="p-3 text-xs">{new Date(d.created_at).toLocaleDateString()}</td>
                <td className="p-3 text-right"><div className="flex justify-end gap-1"><RecordEditButton kind="donors" record={d} fields={DONOR_FIELDS} onDone={load} /><HardDeleteButton collection="donors" record={d} onDone={load} compact /></div></td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={9} className="p-6 text-center text-[#0a0d12]/50">No donors yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
